// 지인에듀가 지문마다 붙여 주는 강의 주소(paragraph_data[].video_url)를 화면에 넣을 모양으로 바꾼다.
//
// 유튜브는 우리 화면 안에 끼워 재생한다(youtube-nocookie, 끝나고 다른 채널 추천 안 띄움).
// 구글 드라이브 등 그 밖의 주소는 끼워 넣지 않고 새 창 링크로 연다. 드라이브는 많은
// 학생이 한꺼번에 보면 "조회수가 너무 많다" 로 막히는 일이 잦다.

const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

// "1m30s", "90", "90s" 같은 시작 시각을 초로.
const toSeconds = (raw) => {
  if (!raw) return 0;
  if (/^\d+$/.test(raw)) return Number(raw);
  const match = String(raw).match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/);
  if (!match) return 0;
  return Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0);
};

export const youtubeIdOf = (url) => {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\.|^m\./, "");
    let id = "";
    if (host === "youtu.be") {
      id = parsed.pathname.slice(1).split("/")[0];
    } else if (host.endsWith("youtube.com") || host.endsWith("youtube-nocookie.com")) {
      if (parsed.pathname === "/watch") id = parsed.searchParams.get("v") || "";
      else {
        const match = parsed.pathname.match(/^\/(?:embed|shorts|live)\/([^/?#]+)/);
        id = match ? match[1] : "";
      }
    }
    return YOUTUBE_ID_PATTERN.test(id) ? id : "";
  } catch (error) {
    return "";
  }
};

// { kind: "youtube", embedUrl } | { kind: "link", url } | null
export const lectureOf = (url) => {
  if (!url || typeof url !== "string") return null;
  const id = youtubeIdOf(url);
  if (id) {
    let start = 0;
    try {
      const parsed = new URL(url);
      start = toSeconds(parsed.searchParams.get("t") || parsed.searchParams.get("start"));
    } catch (error) {
      start = 0;
    }
    // enablejsapi: 탭을 옮기거나 문장 듣기를 누를 때 영상을 멈추게 하려고 켠다.
    const query = new URLSearchParams({ rel: "0", playsinline: "1", modestbranding: "1", enablejsapi: "1" });
    if (start) query.set("start", String(start));
    return { kind: "youtube", embedUrl: `https://www.youtube-nocookie.com/embed/${id}?${query}` };
  }
  if (/^https?:\/\//.test(url)) return { kind: "link", url };
  return null;
};
